import { takeEvery, fork, put, all, call } from "redux-saga/effects"

// Login Redux States
import { 
  FORGET_PASSWORD,
  VERIFY_FORGET_PASSWORD,
  RESEND_FORGET_PASSWORD_CODE,

} from "./actionTypes"
import { 
  forgetPasswordSuccess, 
  forgetPasswordError,

  verifyForgetPasswordSuccess, 
  verifyForgetPasswordFail,

  resendForgetPasswordCodeSuccess, 
  resendForgetPasswordCodeFail 

} from "./actions"

//Include Both Helper File with needed methods
//import { getFirebaseBackend } from "../../../helpers/firebase_helper"
import {
  postForgetPassword,
  verifyForgetPassword,
  resendForgetPasswordCode
} from "helpers/accounts/accounts_backend_helper";

import { toast } from "react-toastify";

//const fireBaseBackend = getFirebaseBackend()

//If account is send successfully send mail link then dispatch redux action's are directly from here.
function* onForgetPassword({ payload: { email, history } }) {
  try {
   
    const response = yield call(postForgetPassword, {
      identifier: email,
    })
   
     

      localStorage.setItem("forgot_password_token", JSON.stringify(response.token));
       yield put(forgetPasswordSuccess(response));
       toast.success(response.message, { autoClose: 2000 });
      history("/forgot-password/verify");
     

   
   
  } catch (error) {
    yield put(forgetPasswordError(error))
    const errorMessage = error.response?.data?.error
    toast.error( errorMessage, { autoClose: 2000 });
  }
}


// VERIFY FORGET PASSWORD
function* onVerifyForgetPassword({ payload: { payload, history } }) {
  try {

    const response = yield call(verifyForgetPassword, {
      otp: payload.code,
      token: payload.token
    })

    console.log("RESPONSE: #", response.token);
    localStorage.setItem("reset_password_token", JSON.stringify(response.token));
    //const token = localStorage.getItem('yeta_reset_token');

    console.log("TOKENI: ", localStorage.getItem("reset_password_token"));
    yield put(verifyForgetPasswordSuccess(response.account))
    toast.success(response.message, { autoClose: 2000 });
      history("/password/reset");

       

  } catch (error) {
      console.log("ERORRRRR: ", error.response.data.error);
      yield put(verifyForgetPasswordFail(error))
      
      toast.error( error.response.data.error, { autoClose: 2000 });
      
  }
    
}

// RESEND FORGET PASSWORD CODE
function* onResendForgetPasswordCode({ payload: token }) {
    try {
        console.log("CODE BEFORE SEND", token);
        const response = yield call(resendForgetPasswordCode, token);
        yield put(resendForgetPasswordCodeSuccess(response));
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        const errorMessage = error.response?.data?.message || "Erreur lors du renvoi du code.";
        yield put(resendForgetPasswordCodeFail(errorMessage));
        toast.error(errorMessage);
    }
}


export function* watchAccountPasswordForget() {
  yield takeEvery(FORGET_PASSWORD, onForgetPassword)
  yield takeEvery(VERIFY_FORGET_PASSWORD, onVerifyForgetPassword)
  yield takeEvery(RESEND_FORGET_PASSWORD_CODE, onResendForgetPasswordCode)
}

function* forgetPasswordSaga() {
  yield all([fork(watchAccountPasswordForget)])
}

export default forgetPasswordSaga
